import React, { useState, useEffect } from "react";
import axios from "axios";
import baseURL from "../../../Url/NodeBaseURL";
import { pdf } from "@react-pdf/renderer";
import InventoryPDFDoc from "./InventoryPDFDoc";

const InventoryDataCard = () => {
  const [inventoryData, setInventoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expanded, setExpanded] = useState({});
  const [selectedVendors, setSelectedVendors] = useState({});
  useEffect(() => {
    const fetchInventoryData = async () => {
      try {
        setLoading(true);
        const [inventoryRes, purchaseRes] = await Promise.all([
          axios.get(`${baseURL}/api/inventory-data`),
          axios.get(`${baseURL}/api/purchase-orders`),
        ]);

        if (inventoryRes.data.success && purchaseRes.data.success) {
          const inventoryData = inventoryRes.data.data;
          const purchaseOrders = purchaseRes.data.data;

          const usedOpenTagIds = new Set(purchaseOrders.map((po) => po.opentag_id)); //getting the opentag id from purchase orders

          const filteredInventory = inventoryData.filter((item) =>
            item.allVendors.every((vendor) => !usedOpenTagIds.has(vendor.opentag_id))
          );

          setInventoryData(filteredInventory);
        } else {
          setError("Failed to fetch inventory or purchase data");
        }
      } catch (err) {
        console.error("Error fetching inventory data:", err);
        setError("Error fetching inventory data");
      } finally {
        setLoading(false);
      }
    };

    fetchInventoryData();
  }, []);

  const toggleExpand = (category) => {
    setExpanded((prev) => ({ ...prev, [category]: !prev[category] }));
  };
  const handleVendorSelect = (rowKey, vendorIndex) => {
    setSelectedVendors((prev) => ({
      ...prev,
      [rowKey]: prev[rowKey] === vendorIndex ? null : vendorIndex,
    }));
  };
    const handleGeneratePDFs = async () => {
    const vendorMap = {};

    Object.keys(selectedVendors).forEach((rowKey) => {
      const vendorIndex = selectedVendors[rowKey];
      if (vendorIndex == null) return;

      const item = inventoryData.find(
        (inv) => `${inv.category}-${inv.subcategory}-${inv.designMaster}` === rowKey
      );
      if (!item) return;

      const vendor = item.allVendors[vendorIndex];
      if (!vendor) return;

      if (!vendorMap[vendor.vendor_name]) {
        vendorMap[vendor.vendor_name] = { vendor, items: [] };
      }
      vendorMap[vendor.vendor_name].items.push({ item, vendor });
    });

    for (const vendorName in vendorMap) {
      const vendorBatch = vendorMap[vendorName];
      const purchaseOrderId = `PO-${Date.now()}-${Math.floor(Math.random() * 1000)}`;

      vendorBatch.items.forEach(({ item }) => {
        item.purchase_order_id = purchaseOrderId;
      });
      vendorBatch.purchase_order_id = purchaseOrderId;

      try {
        const payload = {
          order_date: new Date().toISOString().slice(0, 10),
          products: vendorBatch.items.map(({ vendor }) => ({
            opentag_id: vendor.opentag_id, 
            purchase_order_id: purchaseOrderId,
          })),
          vendor_name: vendorName,
        };

        await axios.post(`${baseURL}/api/purchase-orders`, payload);

        const pdfWindow = window.open("", "_blank");
        console.log("vendorBatch data is", vendorBatch)
        const blob = await pdf(<InventoryPDFDoc vendor={vendorBatch} />).toBlob();
        const blobURL = URL.createObjectURL(blob);

        if (pdfWindow) pdfWindow.location.href = blobURL;
      } catch (err) {
        console.error("Error saving products or generating PDF for vendor:", vendorName, err);
        alert(`Error for vendor ${vendorName}`);
      }
    }
  };


  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <div>Loading inventory data...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ textAlign: "center", padding: "20px", color: "red" }}>
        <div>{error}</div>
      </div>
    );
  }

  if (!inventoryData || inventoryData.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <div>No inventory data available</div>
      </div>
    );
  }
  const groupedData = inventoryData.reduce((acc, curr) => {
    if (!acc[curr.category]) {
      acc[curr.category] = [];
    }
    acc[curr.category].push(curr);
    return acc;
  }, {});

  return (
    <div
      style={{
        maxHeight: "300px",
        overflowY: "auto",
        width: "100%",
        marginTop: "8px",
        position: "relative",
      }}
    >
      <div
        style={{
          maxHeight: "240px",
          overflowY: "auto",
          width: "100%",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "13px",
          }}
        >
          <thead>
            <tr
              style={{
                backgroundColor: "#f5f5f5",
                position: "sticky",
                top: 0,
              }}
            >
              <th
                style={{
                  padding: "6px 10px",
                  textAlign: "left",
                  borderBottom: "1px solid #ddd",
                  fontWeight: "600",
                  color: "#b77318",
                }}
              >
                Category
              </th>
              <th
                style={{
                  padding: "6px 10px",
                  textAlign: "left",
                  borderBottom: "1px solid #ddd",
                  fontWeight: "600",
                  color: "#b77318",
                }}
              >
                Subcategory
              </th>
              <th
                style={{
                  padding: "6px 10px",
                  textAlign: "left",
                  borderBottom: "1px solid #ddd",
                  fontWeight: "600",
                  color: "#b77318",
                }}
              >
                Product Design
              </th>
              <th
                style={{
                  padding: "6px 10px",
                  textAlign: "left",
                  borderBottom: "1px solid #ddd",
                  fontWeight: "600",
                  color: "#b77318",
                }}
              >
                Weight
              </th>
              <th
                style={{
                  padding: "6px 10px",
                  textAlign: "left",
                  borderBottom: "1px solid #ddd",
                  fontWeight: "600",
                  color: "#b77318",
                }}
              >
                Purity
              </th>
              <th
                style={{
                  padding: "6px 10px",
                  textAlign: "center",
                  borderBottom: "1px solid #ddd",
                  fontWeight: "600",
                  color: "#b77318",
                }}
              >
                Quantity
              </th>
              {/* <th style={{
              padding: "6px 10px",
              textAlign: "left",
              borderBottom: "1px solid #ddd",
              fontWeight: "600",
              color: "#b77318",
            }}>
              Best Vendor
            </th>
            <th style={{
              padding: "6px 10px",
              textAlign: "center",
              borderBottom: "1px solid #ddd",
              fontWeight: "600",
              color: "#b77318",
            }}>
              Making Charges
            </th> */}
            </tr>
          </thead>
          <tbody>
            {inventoryData.map((item, index) => {
              const key = `${item.category}-${item.subcategory}-${item.designMaster}`;
              const isOpen = expanded[key];
              return (
                <React.Fragment key={key}>
                  <tr
                    key={index}
                    style={{
                      cursor: "pointer",
                      borderBottom: "1px solid #eee",
                    }}
                    onClick={(e) => {
                      // Prevent navigation when clicking on expand/collapse arrow
                      if (
                        e.target.textContent.includes("▼") ||
                        e.target.textContent.includes("▶")
                      ) {
                        toggleExpand(key);
                      }
                    }}
                    onMouseEnter={(e) => {
                      e.target.parentElement.style.backgroundColor = "#f8f9fa";
                    }}
                    onMouseLeave={(e) => {
                      e.target.parentElement.style.backgroundColor =
                        "transparent";
                    }}
                  >
                    <td
                      style={{
                        padding: "6px 10px",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "120px",
                        fontWeight: "400",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={isOpen}
                          onChange={() => toggleExpand(key)}
                        />
                        <span>{item.category}</span>
                      </div>
                    </td>
                    <td
                      style={{
                        padding: "6px 10px",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "120px",
                        fontWeight: "400",
                      }}
                    >
                      {item.subcategory}
                    </td>
                    <td
                      style={{
                        padding: "6px 10px",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "120px",
                        fontWeight: "400",
                      }}
                    >
                      {item.designMaster}
                    </td>
                    <td
                      style={{
                        padding: "6px 10px",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "120px",
                        fontWeight: "400",
                      }}
                    >
                      {item.weightBW}
                    </td>
                    <td
                      style={{
                        padding: "6px 10px",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "120px",
                        fontWeight: "400",
                      }}
                    >
                      {item.Purity}
                    </td>
                    <td
                      style={{
                        padding: "6px 10px",
                        textAlign: "center",
                        color: item.count === 1 ? "red" : "inherit",
                        fontWeight: item.count === 1 ? "bold" : "400",
                      }}
                    >
                      {item.count}
                    </td>
                    {/* <td style={{ 
                padding: "6px 10px",
                textAlign: "left",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "120px",
                fontWeight: "400"
              }}>
                {item.bestVendor.name}
              </td> */}
                    {/* <td style={{ 
                padding: "6px 10px",
                textAlign: "center",
                color: "#388e3c",
                fontWeight: "500"
              }}>
                ₹{item.bestVendor.mcPerGram}
              </td> */}
                  </tr>
                  {isOpen && (
                    <tr>
                      <td colSpan={6} style={{ padding: "0px 10px" }}>
                        <table
                          style={{
                            width: "100%",
                            fontSize: "12px",
                            backgroundColor: "#f9f9f9",
                            marginTop: "5px",
                            borderCollapse: "collapse",
                          }}
                        >
                          <thead>
                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                              <th style={{ textAlign: "left", padding: "6px" }}>
                                Vendor Name
                              </th>
                              <th style={{ textAlign: "left", padding: "6px" }}>
                                Avg MC/Gram (₹)
                              </th>
                              <th style={{ textAlign: "left", padding: "6px" }}>
                                Wastage %
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {item.allVendors.map((vendor, i) => {
                              const isSelected = selectedVendors[key] === i;
                              const disabled =
                                selectedVendors[key] != null && !isSelected;

                              return (
                                <tr
                                  key={`vendor-${i}`}
                                  style={{
                                    transition: "background-color 0.2s",
                                    backgroundColor: isSelected
                                      ? "#e9ecef"
                                      : "transparent",
                                  }}
                                >
                                  <td
                                    style={{
                                      padding: "6px 10px",
                                      textAlign: "left",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      maxWidth: "120px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={isSelected}
                                        disabled={disabled}
                                        onChange={() =>
                                          handleVendorSelect(key, i)
                                        }
                                      />
                                      <span>{vendor.vendor_name}</span>
                                    </div>
                                  </td>
                                  <td style={{ padding: "6px" }}>
                                    ₹
                                    {Number(
                                      vendor.avg_mc_per_gram || 0
                                    ).toFixed(2)}
                                  </td>
                                  <td style={{ padding: "6px" }}>
                                    {vendor.wastage_per}%
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "10px",
          paddingRight: "10px",
        }}
      >
        <button
          style={{
            backgroundColor: "#b77318",
            color: "white",
            border: "none",
            padding: "6px 12px",
            borderRadius: "4px",
            cursor: "pointer",
          }}
          onClick={handleGeneratePDFs}
        >
          Apply
        </button>
      </div>
    </div>
  );
};

export default InventoryDataCard;
